/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientTreatmentRecords = sqliteTable('patient_treatment_records', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  invoice_id: text('invoice_id'),
  invoice_item_id: text('invoice_item_id'),
  date: text('date'),
  tooth_nos: text('tooth_nos'),
  procedure_name: text('procedure_name'),
  amount_charged_cents: integer('amount_charged_cents'),
  amount_paid_cents: integer('amount_paid_cents'),
  next_appointment_at: text('next_appointment_at'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
